import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';

const mapOnlineDocumentFromApi = (
  resp: ApiOnlineDocumentResponse
): OnlineDocument => {
  return {
    id: resp.id,
    name: resp.name ?? '',
    createdAt: new Date(resp.created_at * 1000),
    upload: resp.upload != null ? mapFileFromApi(resp.upload) : null,
    isSigned: resp.is_signed,
  };
};

export default mapOnlineDocumentFromApi;
